// extracted by mini-css-extract-plugin
module.exports = {"btn":"SliderArrow_btn__Hocxn","_prev":"SliderArrow__prev__L_G7H","_next":"SliderArrow__next__MrrGR","_big":"SliderArrow__big__m_z_E"};